

<template>
    <div class="intent">
        <div style="height:20px"></div>
        <div  v-if="list && list.length > 0" class="order-list">
            <div class="intent-block order-block" v-for="(item, index) in list" :key="item.id">
                <div class="item">
                  <div class="label">姓名</div>
                  <div class="value">{{item.name}}</div>
                </div>
                <div class="item">
                  <div class="label">核销商户</div>
                  <div class="value">{{item.shopName}}</div>
                </div>
                <div class="item">
                  <div class="label">核销时间</div>
                  <div class="value">{{item.verifyTime}}</div>
                </div>
            </div>
        </div>
        <div v-else class="no-data">
            您还没有核销记录
        </div>
    </div>
</template>

<script>
import { MessageBox, Toast } from "mint-ui"
import wx from "weixin-js-sdk"
export default {
    //获取openId
    data(){
        return {
            code: '',
            openId: '',
            wechatReady: false,
            list:[]
        }
    },
    mounted(){
        this.openId = localStorage.getItem("openId");
        this.getWechatSign();
        wx.ready(function(){

        });
        wx.error(function(res){
            MessageBox.alert("微信支付初始化失败");
        });
    },
    methods:{
        getWechatSign:function(){
            const self = this;
            let url = location.href;
            console.log("url" + url);
            let encodeUrl = encodeURIComponent(url);
            this.$http.get("/bicycle/inter/getWechatSign?url="+encodeUrl).then(function(res){
                if(res.data.status != 200){
                     MessageBox.alert(res.data.errorMsg);
                }else{
                    let e = res.data.data;

                    if(self.$route.query.code){
                        self.code = self.$route.query.code;
                        wx.config({
                            debug: false, // 关闭调试模式
                            appId: e.appId, // 必填，公众号的唯一标识
                            timestamp: e.timestamp, // 必填，生成签名的时间戳
                            nonceStr: e.nonceStr, // 必填，生成签名的随机串
                            signature: e.signature,// 必填，签名
                            jsApiList: [
                                'chooseWXPay'
                            ]// 必填
                        });
                        //获取openId
                        if(!self.openId){
                            self.getOpenId();
                        }else{
                            self.getList();
                            self.wechatReady = true;
                        }

                        // url = location.origin + location.pathname;
                        // console.log("url" + url);
                        // history.pushState({}, document.title, url);
                    }else{
                        let currentUrl = location.href;
                        let redirectUrl = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +e.appId+ "&redirect_uri="+ encodeURIComponent(currentUrl)+"&response_type=code&scope=snsapi_base&state=123#wechat_redirect";
                        window.location.href = redirectUrl;
                    }
                }
            }).catch(function(error){
                console.log(error)
            });
        },
         getOpenId:function(){
            const self = this;
            self.$http.get("/bicycle/inter/getOpenId?code=" + self.code).then(function(res){
                    if(res.data.status != 200){
                        MessageBox.alert(res.data.errorMsg);
                    }else{
                        self.openId = res.data.data;
                        localStorage.setItem("openId", self.openId);
                        self.getOrders();

                        self.wechatReady = true;
                    }
                }).catch(function(error){
                    console.log(error)
                });
        },
        getList:function(){
            const self = this;
            self.$http.get("/bicycle/inter/coupon/verifyList?openId=" + self.openId).then(function(res){
                    if(res.data.status != 200){
                        MessageBox.alert(res.data.errorMsg);
                    }else{
                        self.list = res.data.data;
                    }
                }).catch(function(error){
                    console.log(error)
                });
        }
    }
}
</script>

<style scoped>
.order-block{
    display: flex;
    align-items: center;
    flex-direction: column;
}
.item{
  display: flex;
  width: 100%;
  padding: 4px 0px;
}
.label{
  width: 80px;
  margin-right: 24px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/pages/MobileVerifyList.vue